// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  lookupServiceUrl: "/api/eservice/Lookups/LoadLookup",
  //resourcesRootPath: '../../../EServicesAssets/',
  resourcesRootPath: 'EServicesAssets/',
  globalResourcesFolder: 'Shared',
  globalResourcesFileName: 'GlobalResources',
  getCurrentUser: '/api/eservice/Common/GetCurrentUser',
  sendToken: '/api/eservice/Common/SendToken',
  //base used in happiness meter
  HappinessMeter_checkRequest: "/api/eservice/HappinessMeter/CheckRequest",
  HappinessMeter_updateRequest: "/api/eservice/HappinessMeter/UpdateRequest",

  downloadAttachmentUrl: "/api/eservice/Document/GetDownloadableLinkForBulk",

  //baseUrl: 'http://mofaic.dev.com/',
  successPage: 'Services/Forms/confirmation',
  paymentPage: 'Services/Forms/Pay',
  paymentFABPage: 'Services/Forms/Pay-FAB',
  appointmentPage: 'Services/Forms/Appointments',
  serviceBase: 'Services/Forms/',
  //site key captcha
  sitekeyCaptcha: "6LdDdpIUAAAAAGw6HL4jW8fVTpJ0tsbRkAV0a_ec",
  HappinessMeterKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ODR9.GKU_oTxOp1NABHpY0xTrnSXZ1C0KhjhNitx6RZJKMB4",
  //Damaged passport
  damagedPassport_loadApplication: "/api/eservice/ServiceDamagedPassport/LoadApplication",
  damagedPassport_saveApplication: "/api/eservice/ServiceDamagedPassport/SaveApplication",
  //Expired Passport
  expiredPassport_loadApplication: "/api/eservice/ExpiredPassportService/LoadApplication",
  expiredPassport_saveApplication: "/api/eservice/ExpiredPassportService/SaveApplication",
  //Renew Passport
  renewPassport_loadApplication: "/api/eservice/RenewPassportService/LoadApplication",
  renewPassport_saveApplication: "/api/eservice/RenewPassportService/SaveApplication",
  //Lost or stolen passport
  lostOrStolenPassport_loadApplication: "/api/eservice/LostOrStolenPassportService/LoadApplication",
  lostOrStolenPassport_saveApplication: "/api/eservice/LostOrStolenPassportService/SaveApplication",
  //Newborn up to one year passport
  newbornUTOYPassport_loadApplication: "/api/eservice/NewbornsUpToOneYearPassportService/LoadApplication",
  newbornUTOYPassport_saveApplication: "/api/eservice/NewbornsUpToOneYearPassportService/SaveApplication",
  //One Year And Above Passport
  oneYearAndAbove_loadApplication: "/api/eservice/NewbornsFromOneYearPassportService/LoadApplication",
  oneYearAndAbove_saveApplication: "/api/eservice/NewbornsFromOneYearPassportService/SaveApplication",

  //NewDiplomaticService
  NewDiplomaticService_loadApplication: "/api/eservice/NewDiplomaticPassport/LoadApplication",
  NewDiplomaticService_saveApplication: "/api/eservice/NewDiplomaticPassport/SaveApplication",
  AddFamilyDiplomaticService_loadApplication: "/api/eservice/AddFamilyDiplomaticPassport/LoadApplication",
  AddFamilyDiplomaticService_saveApplication: "/api/eservice/AddFamilyDiplomaticPassport/SaveApplication",
  ModifyDiplomaticService_loadApplication: "/api/eservice/ModifyDiplomaticPassport/LoadApplication",
  ModifyDiplomaticService_saveApplication: "/api/eservice/ModifyDiplomaticPassport/SaveApplication",
  CancelDiplomaticService_loadApplication: "/api/eservice/CancelDiplomaticPassport/LoadApplication",
  CancelDiplomaticService_saveApplication: "/api/eservice/CancelDiplomaticPassport/SaveApplication",
  ReplaceDiplomaticService_loadApplication: "/api/eservice/ReplaceDiplomaticPassport/LoadApplication",
  ReplaceDiplomaticService_saveApplication: "/api/eservice/ReplaceDiplomaticPassport/SaveApplication",
  RenewDiplomaticService_loadApplication: "/api/eservice/RenewDiplomaticPassport/LoadApplication",
  RenewDiplomaticService_saveApplication: "/api/eservice/RenewDiplomaticPassport/SaveApplication",
  DiplomaticService_loadOldRequestApplication: "/api/eservice/NewDiplomaticPassport/loadOldApplication",
  AddFamilyDiplomaticService_loadOldRequestApplication: "/api/eservice/AddFamilyDiplomaticPassport/loadOldApplication",
  RenewDiplomaticService_loadOldRequestApplication: "/api/eservice/RenewDiplomaticPassport/loadOldApplication",
  ReplaceDiplomaticService_loadOldRequestApplication: "/api/eservice/ReplaceDiplomaticPassport/loadOldApplication",
  CancelDiplomaticService_loadOldRequestApplication: "/api/eservice/CancelDiplomaticPassport/loadOldApplication",

  //DiplomaticService2022
  NewDiplomaticService_searchByIDApplication: "/api/eservice/NewDiplomaticPassport2022/SearchByIDApplication",
  NewDiplomaticService_loadApplication2022: "/api/eservice/NewDiplomaticPassport2022/LoadApplication",
  NewDiplomaticService_saveApplication2022: "/api/eservice/NewDiplomaticPassport2022/SaveApplication",
  CancelDiplomaticService_loadApplication2022: "/api/eservice/CancelDiplomaticPassport2022/LoadApplication",
  CancelDiplomaticService_saveApplication2022: "/api/eservice/CancelDiplomaticPassport2022/SaveApplication",
  ReplaceDiplomaticService_loadApplication2022: "/api/eservice/ReplaceDiplomaticPassport2022/LoadApplication",
  ReplaceDiplomaticService_saveApplication2022: "/api/eservice/ReplaceDiplomaticPassport2022/SaveApplication",
  RenewDiplomaticService_loadApplication2022: "/api/eservice/RenewDiplomaticPassport2022/LoadApplication",
  RenewDiplomaticService_saveApplication2022: "/api/eservice/RenewDiplomaticPassport2022/SaveApplication",

  //Establishment ID
  NewEstablishmentID: "99FC9184-D7B0-EC11-910F-0050569917F4",
  RenewEstablishmentID: "07ED6649-D4B3-EC11-910F-0050569917F4",
  ModifyEstablishmentID: "3CBD12F3-D4B3-EC11-910F-0050569917F4",
  CancelEstablishmentID: "C0B5815D-D5B3-EC11-910F-0050569917F4",
  NewEstablishmentIDservice_loadApplication: "/api/eservice/NewEstablishmentID/LoadApplication",
  NewEstablishmentIDservice_saveApplication: "/api/eservice/NewEstablishmentID/SaveApplication",
  EstablishmentIDservice_searchByID: "/api/eservice/NewEstablishmentID/ValidateSignatory",
  RenewEstablishmentIDservice_loadApplication: "/api/eservice/RenewEstablishmentID/LoadApplication",
  RenewEstablishmentIDservice_saveApplication: "/api/eservice/RenewEstablishmentID/SaveApplication",
  UpdateEstablishmentIDservice_loadApplication: "/api/eservice/UpdateEstablishmentID/LoadApplication",
  UpdateEstablishmentIDservice_saveApplication: "/api/eservice/UpdateEstablishmentID/SaveApplication",
  CancelEstablishmentIDservice_loadApplication: "/api/eservice/CancelEstablishmentID/LoadApplication",
  CancelEstablishmentIDservice_saveApplication: "/api/eservice/CancelEstablishmentID/SaveApplication",

  //Complaint Service
  complaint_loadApplication: "/api/eservice/Complaint/LoadApplication",
  complaint_saveApplication: "/api/eservice/Complaint/SaveApplication",
  complaint_checkRequestValidation: "/api/eservice/Complaint/CheckUserIsVaildToViewApplication",
  complaint_resendMail: "/api/eservice/Complaint/ResendSecuirtyCode",
  //Inquiry service
  inquiry__loadApplication: "/api/eservice/Inquiry/LoadApplication",
  inquiry_saveApplication: "/api/eservice/Inquiry/SaveApplication",
  inquiry_checkRequestValidation: "/api/eservice/Inquiry/CheckUserIsVaildToViewApplication",
  inquiry_resendMail: "/api/eservice/Inquiry/ResendSecuirtyCode",
  //Suggestion
  suggestion_loadApplication: "/api/eservice/Suggestion/LoadApplication",
  suggestion_saveApplication: "/api/eservice/Suggestion/SaveApplication",
  //Tawajudi
  tawajudi_loadApplication: "/api/eservice/Tawajudi/LoadApplication",
  tawajudi_saveApplication: "/api/eservice/Tawajudi/SaveApplication",
  tawajudi_cancelUrl: "/api/eservice/Tawajudi/CancelRequest",

  //Uploader
  uploader_add: "/api/eservice/Document/Add",
  uploader_getRealFile: "/api/eservice/Document/GetFile",
  uploader_download: "/api/eservice/Document/GetDownloadableLink",
  uploader_downloadTemp: "/api/eservice/Document/GetDownloadableLinkForTemp",
  crmUploader_download: "/api/eservice/CRMDocument/GetDownloadableLink",
  crmUploader_getRealFile: "/api/eservice/CRMDocument/GetFile",
  crmUploader_add: "/api/eservice/CRMDocument/Add",
  document_crmGetDocumentConfiguration: "/api/eservice/CRMDocument/GetDocumentConfiguration",

  //Diplomatic Passports
  Issuance: "961c8443-889f-ec11-910f-0050569917f4",
  Cancellation: "d5d9c777-8a9f-ec11-910f-0050569917f4",
  Renew: "183357c4-899f-ec11-910f-0050569917f4",
  Replacement: "dfa21f7d-8c9f-ec11-910f-0050569917f4",



  //document-service
  document_getDocumentConfiguration: "/api/eservice/Document/GetDocumentConfiguration",

  //Payment
  RetrievePaymentTransaction: "/api/eservice/Payment/RetrievePaymentTransaction",
  InitiatePayment: "/api/eservice/Payment/InitiatePayment",
  RetrievePaymentResponse: "/api/eservice/Payment/RetrievePaymentResponse",

  //FABPayment
  RetrievePaymentFABTransaction: "/api/eservice/Payment/FABRetrievePaymentTransaction",
  InitiatePaymentFAB: "/api/eservice/Payment/FABInitiatePayment",
  RetrievePaymenFABtResponse: "/api/eservice/FABPayment/RetrievePaymentResponse",

  //Attestation
  attestation_loadApplication: "/api/eservice/Attestation/LoadApplication",
  attestation_saveApplication: "/api/eservice/Attestation/SaveApplication",
  attestation_CancelRequestTask: "/api/eservice/Attestation/CancelRequestTask",
  attestation_checkIsDateValidLink: "/api/eservice/Attestation/IsvalidToSubmitDelivery",
  attestation_checkHappinessCenterMessage: "/api/eservice/Attestation/CheckHappinessCenterMessage",
  getStepConfigration: "/api/eservice/StepsBar/CheckRequest",
  happiness_Center_Courier: "9858AC30-B8D8-4D8B-B5BB-68EA0C53F707",
  happiness_Center_Pre_paid: "B132B8AE-AFFA-473E-A902-813F558CFA90",
  happiness_Center_CourierSTG: "5896fb6d-c8f6-496e-8c81-679ea4b22c8b",
  attestation_getAppointmentLink: "/api/eservice/Attestation/GetAppointmentLink",
  attestation_validateRelatedRequest: "/api/eservice/Attestation/ValidateRelatedRequest",


  //TreatmentRequest
  treatmentRequest_loadApplication: "/api/eservice/TreatmentRequest/LoadApplication",
  treatmentRequest_saveApplication: "/api/eservice/TreatmentRequest/SaveApplication",
  //CrisesAndDisasters
  CrisesAndDisasters_loadApplication: "/api/eservice/CrisesAndDisasters/LoadApplication",
  CrisesAndDisasters_saveApplication: "/api/eservice/CrisesAndDisasters/SaveApplication",
  //Air And Land Transportations
  airAndLandTransportations_loadApplication: "/api/eservice/AirAndLandTransportationsService/LoadApplication",
  airAndLandTransportations_saveApplication: "/api/eservice/AirAndLandTransportationsService/SaveApplication",
  //Cases
  cases_loadApplication: "/api/eservice/Cases/LoadApplication",
  cases_saveApplication: "/api/eservice/Cases/SaveApplication",

  //lostAndFound
  lostAndFound_loadApplication: "/api/eservice/LostAndFoundService/LoadApplication",
  lostAndFound_saveApplication: "/api/eservice/LostAndFoundService/SaveApplication",
  lostAndFound_createTask: "/api/eservice/LostAndFoundService/CreateTask",
  //AccidentsAndReports
  AccidentsAndReports_loadApplication: "/api/eservice/AccidentsAndReports/LoadApplication",
  AccidentsAndReports_saveApplication: "/api/eservice/AccidentsAndReports/SaveApplication",

  //Certificate For Whom Concern
  certificateForWhomConcern_loadApplication: "/api/eservice/CertificateForWhomConcernService/LoadApplication",
  certificateForWhomConcern_saveApplication: "/api/eservice/CertificateForWhomConcernService/SaveApplication",
  //Tawajudi Institutions
  tawajudiInstitutions_loadApplication: "/api/eservice/TawajudiInstitutions/LoadApplication",
  tawajudiInstitutions_saveApplication: "/api/eservice/TawajudiInstitutions/SaveApplication",
  tawajudiInstitutions_cancelApplication: "/api/eservice/TawajudiInstitutions/CancelRequest",
  InstitutionsEmployees_loadEmployees: "/api/eservice/TawajudiInstitutions/LoadEmployees",
  InstitutionsEmployees_saveEmployees: "/api/eservice/TawajudiInstitutions/SaveEmployees",
  InstitutionsEmployees_CountryHasWarning: "api/mobile/v2/TravelAdvisoriesAndWarningsAPIs/getTravelWarningsByCountry?countryID=",

  //NewID
  newID_loadApplication: "/api/eservice/NewID/LoadIDApplication",
  newID_saveApplication: "/api/eservice/NewID/SaveApplication",
  newID_findByID: "/api/eservice/NewID/FindByID",
  newID_findByIDForReplacement: "/api/eservice/NewID/FindByIDForReplacement",

  //RenewID
  renewID_loadApplication: "/api/eservice/RenewID/LoadApplication",
  renewID_saveApplication: "/api/eservice/RenewID/SaveApplication",
  renewID_findByID: "/api/eservice/RenewID/FindByID",

  //RenewID
  replaceID_loadApplication: "/api/eservice/ReplaceID/LoadApplication",
  replaceID_saveApplication: "/api/eservice/ReplaceID/SaveApplication",
  replaceID_findByID: "/api/eservice/ReplaceID/FindByID",
  //CancelID
  cancelID_loadApplication: "/api/eservice/CancelID/LoadApplication",
  cancelID_saveApplication: "/api/eservice/CancelID/SaveApplication",
  cancelID_findByID: "/api/eservice/CancelID/FindByID",
  //ModifyID
  ModifyID_loadApplication: "/api/eservice/ModifyID/LoadApplication",
  ModifyID_saveApplication: "/api/eservice/ModifyID/SaveApplication",
  ModifyID_findByID: "/api/eservice/ModifyID/FindByID",

  //MissionPassportIssuance
  missionPassportIssuance_loadApplication: "/api/eservice/MissionPassportIssuance/LoadApplication",
  missionPassportIssuance_saveApplication: "/api/eservice/MissionPassportIssuance/SaveApplication",

  //MissionPassportICancellation
  missionPassportCancellation_loadApplication: "/api/eservice/MissionPassportICancellation/LoadApplication",
  missionPassportCancellation_saveApplication: "/api/eservice/MissionPassportICancellation/SaveApplication",
  missionPassportCancellation_findByID: "/api/eservice/MissionPassportICancellation/FindByID",
  //NewSpecialPassport
  newSpecialPassport_loadApplication: "/api/eservice/NewSpecialPassport/LoadApplication",
  newSpecialPassport_saveApplication: "/api/eservice/NewSpecialPassport/SaveApplication",
  //NewSpecialPassport
  renewSpecialPassport_loadApplication: "/api/eservice/RenewSpecialPassport/LoadApplication",
  renewSpecialPassport_saveApplication: "/api/eservice/RenewSpecialPassport/SaveApplication",
  renewSpecialPassport_findByID: "/api/eservice/RenewSpecialPassport/FindByID",
  addFamilySpecialPassport_loadApplication: "/api/eservice/AddNewFamilySpecialPassport/LoadApplication",
  addFamilySpecialPassport_saveApplication: "/api/eservice/AddNewFamilySpecialPassport/SaveApplication",
  addFamilySpecialPassport_findByID: "/api/eservice/AddNewFamilySpecialPassport/FindByID",
  modifySpecialPassport_loadApplication: "/api/eservice/ModifySpecialPassport/LoadApplication",
  modifySpecialPassport_saveApplication: "/api/eservice/ModifySpecialPassport/SaveApplication",
  modifySpecialPassport_findByID: "/api/eservice/ModifySpecialPassport/FindByID",
  cancelSpecialPassport_loadApplication: "/api/eservice/CancelSpecialPassport/LoadApplication",
  cancelSpecialPassport_saveApplication: "/api/eservice/CancelSpecialPassport/SaveApplication",
  cancelSpecialPassport_findByID: "/api/eservice/CancelSpecialPassport/FindByID",
  replaceSpecialPassport_loadApplication: "/api/eservice/ReplaceSpecialPassport/LoadApplication",
  replaceSpecialPassport_saveApplication: "/api/eservice/ReplaceSpecialPassport/SaveApplication",
  replaceSpecialPassport_findByID: "/api/eservice/ReplaceSpecialPassport/FindByID",
  newSpecialPassport_findByID: "/api/eservice/NewSpecialPassport/FindByID",
  //MissionPassportICancellation
  scholarship_loadApplication: "/api/eservice/Scholarship/LoadApplication",
  scholarship_saveApplication: "/api/eservice/Scholarship/SaveApplication",
  scholarship_findByID: "/api/eservice/Scholarship/IsIDNumberHasRequest",
  scholarship_isServiceavailable: "/api/eservice/Scholarship/IsServiceAvailable",
  scholarship_CheckApplication: "/api/eservice/Scholarship/CheckApplication",
  scholarship_TopUniversities: "/api/features/TopUniversities/GetTopUniversitiesListAPI",
  //TwajudiResidents
  twajudiResidents_loadApplication: "/api/eservice/TwajudiResidents/LoadApplication",
  twajudiResidents_saveApplication: "/api/eservice/TwajudiResidents/SaveApplication",
  twajudiResidents_updateApplication: "/api/eservice/TwajudiResidents/UpdateApplication",
  twajudiResidents_checkRequest: "/api/eservice/TwajudiResidents/CheckApplication",

  //Appointments
  Appointments_saveApplication: "/api/eservice/Appointments/SaveApplication",
  Appointments_loadApplication: "/api/eservice/Appointments/LoadApplication",
  Appointments_loadCalenedarDaySlots: "/api/eservice/Appointments/LoadCalenedarDaySlots",
  Appointments_tempReserveSlotOnClick: "/api/eservice/Appointments/TempReserveSlotOnClick",
  Appointments_updateOrCancleAppointment: "/api/eservice/Appointments/UpdateOrCancleAppointment",
  Appointments_numberOfDaysToReserveAppointments: "7",
  Appointments_numberOfDaysBetweenAppoitnments: "2",
  Appointments_timerFinishedIn: "300",
  Appointments_releaseSlotOnTimerStop: "/api/eservice/Appointments/ReleaseSlotOnTimerStop",
  EducationalInside: "A34830FC-74BE-40B5-A64F-7B0E114C8E9E",
  EducationalOutside: "EBAC6096-D0C2-4463-8DA3-A736826318FB",
  BirthOrHealthCetificateInside: "B27EF500-B43F-48E8-B854-EBC74348A886",
  BirthOrHealthCetificateOutside: "F95C4999-49CC-42AC-8B57-8504A701C004",

  //Visit Services
  mainVisit_loadApplication: "/api/eservice/MainVisit/LoadApplication",
  mainVisit_saveApplication: "/api/eservice/MainVisit/SaveApplication",
  mainVisit_cancelApplication: "/api/eservice/MainVisit/CancelApplication",
  mainVisit_getMember: "/api/eservice/MainVisit/CRMGetMember",
  mainVisit_getAllMembers: "/api/eservice/MainVisit/CRMGetAllMembers",
  mainVisit_submitMember: "/api/eservice/MainVisit/SubmitMember",
  mainVisit_deleteMember: "/api/eservice/MainVisit/CRMDeleteMember",
  mainVisit_getSubServiceVisitors: "/api/eservice/MainVisit/CRMGetAllMembers",
  mainVisit_submitSubServiceVisitors: "/api/eservice/MainVisit/SubmitMember",

  mediaEquipmentPermission_loadApplication: "/api/eservice/MediaEquipmentPermission/LoadApplication",
  mediaEquipmentPermission_saveApplication: "/api/eservice/MediaEquipmentPermission/SaveApplication",
  mediaEquipmentPermission_cancelApplication: "/api/eservice/MediaEquipmentPermission/CancelApplication",
  mediaEquipmentPermission_getEquipmentDetails: "/api/eservice/MediaEquipmentPermission/CRMGetEquipmentDetails",
  mediaEquipmentPermission_getAllEquipmentDetails: "/api/eservice/MediaEquipmentPermission/CRMGetAllEquipmentDetails",
  mediaEquipmentPermission_submitEquipmentDetails: "/api/eservice/MediaEquipmentPermission/CRMSubmitEquipmentDetails",
  mediaEquipmentPermission_deleteEquipmentDetails: "/api/eservice/MediaEquipmentPermission/CRMDeleteEquipmentDetails",
  mediaEquipmentPermission_loadMainVisit: "/api/eservice/MediaEquipmentPermission/LoadMainVisit",
  mediaEquipmentPermission_getMember: "/api/eservice/MediaEquipmentPermission/CRMGetMember",
  mediaEquipmentPermission_deleteMember: "/api/eservice/MediaEquipmentPermission/CRMDeleteMember",
  mediaEquipmentPermission_getSubServiceVisitors: "/api/eservice/MediaEquipmentPermission/CRMGetSubServiceVisitors",
  mediaEquipmentPermission_submitSubServiceVisitors: "/api/eservice/MediaEquipmentPermission/CRMSubmitSubServiceVisitors",

  weaponsPermit_loadApplication: "/api/eservice/WeaponsPermission/LoadApplication",
  weaponsPermit_saveApplication: "/api/eservice/WeaponsPermission/SaveApplication",
  weaponsPermit_cancelApplication: "/api/eservice/WeaponsPermission/CancelApplication",
  weaponsPermit_getMember: "/api/eservice/WeaponsPermission/CRMGetMember",
  weaponsPermit_deleteMember: "/api/eservice/WeaponsPermission/CRMDeleteMember",
  weaponsPermit_getSubServiceVisitors: "/api/eservice/WeaponsPermission/CRMGetSubServiceVisitors",
  weaponsPermit_submitSubServiceVisitors: "/api/eservice/WeaponsPermission/CRMSubmitSubServiceVisitors",
  weaponsPermit_getWeaponsItem: "/api/eservice/WeaponsPermission/CRMGetWeaponsItem",
  weaponsPermit_getAllWeaponsItems: "/api/eservice/WeaponsPermission/CRMGetAllWeaponsItems",
  weaponsPermit_submitWeaponsItem: "/api/eservice/WeaponsPermission/CRMSubmitWeaponsItem",
  weaponsPermit_deleteWeaponsItem: "/api/eservice/WeaponsPermission/CRMDeleteWeaponsItem",
  weaponsPermit_loadMainVisit: "/api/eservice/WeaponsPermission/LoadMainVisit",

  wirelessDevices_loadApplication: "/api/eservice/WirelessDevices/LoadApplication",
  wirelessDevices_saveApplication: "/api/eservice/WirelessDevices/SaveApplication",
  wirelessDevices_cancelApplication: "/api/eservice/WirelessDevices/CancelApplication",
  wirelessDevices_getMember: "/api/eservice/WirelessDevices/CRMGetMember",
  wirelessDevices_deleteMember: "/api/eservice/WirelessDevices/CRMDeleteMember",
  wirelessDevices_getSubServiceVisitors: "/api/eservice/WirelessDevices/CRMGetSubServiceVisitors",
  wirelessDevices_submitSubServiceVisitors: "/api/eservice/WirelessDevices/CRMSubmitSubServiceVisitors",
  wirelessDevices_getWirelessDevice: "/api/eservice/WirelessDevices/CRMGetWirelessDevice",
  wirelessDevices_getAllWirelessDevices: "/api/eservice/WirelessDevices/CRMGetAllWirelessDevices",
  wirelessDevices_submitWirelessDevice: "/api/eservice/WirelessDevices/CRMSubmitWirelessDevice",
  wirelessDevices_deleteWirelessDevice: "/api/eservice/WirelessDevices/CRMDeleteWirelessDevice",
  wirelessDevices_loadMainVisit: "/api/eservice/WirelessDevices/LoadMainVisit",

  //Vehicle services
  registerVehicle_loadApplication: "/api/eservice/RegisterVehicle/LoadApplication",
  registerVehicle_saveApplication: "/api/eservice/RegisterVehicle/SaveApplication",
  renewVehicleRegistration_loadApplication: "/api/eservice/RenewVehicleRegistration/LoadApplication",
  renewVehicleRegistration_saveApplication: "/api/eservice/RenewVehicleRegistration/SaveApplication",
  vehicleOwnershipTransfer_loadApplication: "/api/eservice/VehicleOwnershipTransfer/LoadApplication",
  vehicleOwnershipTransfer_saveApplication: "/api/eservice/VehicleOwnershipTransfer/SaveApplication",
  vehicleInternalTransfer_loadApplication: "/api/eservice/VehicleInternalTransfer/LoadApplication",
  vehicleInternalTransfer_saveApplication: "/api/eservice/VehicleInternalTransfer/SaveApplication",
  vehicleTourismCertificate_loadApplication: "/api/eservice/VehicleTourismCertificate/LoadApplication",
  vehicleTourismCertificate_saveApplication: "/api/eservice/VehicleTourismCertificate/SaveApplication",
  exportVehicle_loadApplication: "/api/eservice/ExportVehicle/LoadApplication",
  exportVehicle_saveApplication: "/api/eservice/ExportVehicle/SaveApplication",
  vehicleIssueDrivingLicense_loadApplication: "/api/eservice/VehicleIssueDrivingLicense/LoadApplication",
  vehicleIssueDrivingLicense_saveApplication: "/api/eservice/VehicleIssueDrivingLicense/SaveApplication",
  vehicleRenewDrivingLicense_loadApplication: "/api/eservice/VehicleRenewDrivingLicense/LoadApplication",
  vehicleRenewDrivingLicense_saveApplication: "/api/eservice/VehicleRenewDrivingLicense/SaveApplication",
  vehicleReplaceDrivingLicense_loadApplication: "/api/eservice/VehicleReplaceDrivingLicense/LoadApplication",
  vehicleReplaceDrivingLicense_saveApplication: "/api/eservice/VehicleReplaceDrivingLicense/SaveApplication",
  parkingAssignment_loadApplication: "/api/eservice/ParkingAssignment/LoadApplication",
  parkingAssignment_saveApplication: "/api/eservice/ParkingAssignment/SaveApplication",
  renewParkingAssignment_loadApplication: "/api/eservice/RenewParkingAssignment/LoadApplication",
  renewParkingAssignment_saveApplication: "/api/eservice/RenewParkingAssignment/SaveApplication",
  vehiclePossessionCertificate_loadApplication: "/api/eservice/VehiclePossessionCertificate/LoadApplication",
  vehiclePossessionCertificate_saveApplication: "/api/eservice/VehiclePossessionCertificate/SaveApplication",

  // Airport Services
  issueAirportPermission_ValidateIdNumber: "/api/eservice/IssueAirportPermission/ValidateDeplomaticIdNumber",
  issueAirportPermission_loadApplication: "/api/eservice/IssueAirportPermission/LoadApplication",
  issueAirportPermission_saveApplication: "/api/eservice/IssueAirportPermission/SaveApplication",
  renewAirportPermission_loadApplication: "/api/eservice/RenewAirportPermission/LoadApplication",
  renewAirportPermission_saveApplication: "/api/eservice/RenewAirportPermission/SaveApplication",
  renewAirportPermission_findByPermitNumber: "/api/eservice/RenewAirportPermission/FindByPermitNumber",
  cancelAirportPermission_loadApplication: "/api/eservice/CancelAirportPermission/LoadApplication",
  cancelAirportPermission_saveApplication: "/api/eservice/CancelAirportPermission/SaveApplication",
  cancelAirportPermission_findByPermitNumber: "/api/eservice/CancelAirportPermission/FindByPermitNumber",
  replaceAirportPermission_loadApplication: "/api/eservice/ReplaceAirportPermission/LoadApplication",
  replaceAirportPermission_saveApplication: "/api/eservice/ReplaceAirportPermission/SaveApplication",
  replaceAirportPermission_findByPermitNumber: "/api/eservice/ReplaceAirportPermission/FindByPermitNumber",

  // Issue NOC
  issueNOC_loadApplication: "/api/eservice/IssueNOC/LoadApplication",
  issueNOC_saveApplication: "/api/eservice/IssueNOC/SaveApplication",
  issueNOC_searchBydiplomaticCardNumber: "/api/eservice/IssueNOC/SearchByDiplomaticCardNumber",
  issueNOC__getCardId: "/api/eservice/IssueNOC/FindCardIdById",

  //CRM Vehicle Services IDs
  VehicleRegisterLicenseID: "06ae4c98-dc53-eb11-910b-0050569917f4",
  VehicleRenewLicenseID: "453524b0-dc53-eb11-910b-0050569917f4",
  VehicleReplaceLicenseID: "8f1dd278-dc53-eb11-910b-0050569917f4",
  VehicleParkingAssignmentID: "80f2c7d9-5b59-eb11-910b-0050569917f4",
  VehicleParkingRenewal: "21fa4711-5d59-eb11-910b-0050569917f4",
  VehicleRenewalID: "98c376c2-6a38-eb11-910b-0050569917f4",
  VehicleExportID: "0dab71f8-e74f-eb11-910b-0050569917f4",
  VehicleInternalTransfereID: "5e0089eb-244f-eb11-910b-0050569917f4",
  VehicleOwnershipTransfereID: "62087f4d-c82f-eb11-910b-0050569917f4",
  VehiclePossessionID: "8d654666-ba4d-eb11-910b-0050569917f4",
  VehicleRegistrationID: "155be63f-092f-eb11-910b-0050569917f4",
  VehicleTourismCertificateIssuanceID: "1c40b66f-394f-eb11-910b-0050569917f4",

  //CRM Airport Services IDs
  AirportIssuePermission: "896EC208-856F-EB11-910B-0050569917F4",
  AirportRenewPermission: "D9A1421F-856F-EB11-910B-0050569917F4",
  AirportCancelPermission: "1A11E29E-866F-EB11-910B-0050569917F4",
  AirportReplacePermission: "32EAAFD6-866F-EB11-910B-0050569917F4",

  IssueNOCID: "0C2D0D11-C18B-EB11-910B-0050569917F4",

  //CRM Visit Services IDs
  MainVisitID: "3272d9c7-431c-eb11-910a-0050569917f4",
  MediaEquipmentID: "3DE0612A-4BCF-EB11-910C-0050569917F4",
  WeaponsID: "35F680D0-FFA7-EB11-910C-0050569917F4",
  WirelessDevicesID: "",
  SubsidiaryMeetingID: "",
  AirportHallCeremonyID: "",

  //Temp Automation Services

  //CRM ID Services
  IssueID: "8DB2EC30-9DF2-EB11-910D-0050569917F4",
  ReplceID: "3C5F806C-9DF2-EB11-910D-0050569917F4",
  RenewID: "09983507-A4F2-EB11-910D-0050569917F4",
  CancelID: "E8028057-9DF2-EB11-910D-0050569917F4",
  ModifyID: "D5D072AE-9DF2-EB11-910D-0050569917F4",
  //Temp Automation Services
  tempAutomationservice_loadApplication: "/api/eservice/TempAutomationServices/LoadApplication",
  tempAutomationservice_saveApplication: "/api/eservice/TempAutomationServices/SaveApplication",
  DeletedCRMMissions: "d381dd12-74fe-e711-80c8-00505699461e,5b82dd12-74fe-e711-80c8-00505699461e,d581dd12-74fe-e711-80c8-00505699461e,f381dd12-74fe-e711-80c8-00505699461e",
  DeletedMissions: "b6d89a55-a9f5-4a26-a877-5c19f2400387,ff72a0d6-12e5-4742-988f-2f7c5d0785e1,79fa136c-a132-4fa8-82b6-e3562d4191f4,f3f68274-ac4c-4757-a435-c6381067def9,83a2f5d2-1db7-48ca-bf1b-cab6873aeafb",
  AramexBulletCities: "1419928d-400f-48a3-a7c9-38d5d29c816b,92e59f32-7de6-448c-8c9d-513a0aa9e575,650ea9b9-07d3-4a2a-9484-6d67793f2b94,978b22b1-4c90-473c-b750-63ad25bce1f3",
  CountryExecluseive: "100429f6-3c58-4674-8f88-ae439f94408a,6a569bf9-7922-4923-b43b-b44dd105e32a",
  //Emergancy services

  Emergency_loadApplication_test: "/api/eservice/ServiceEmergencyPassport/LoadApplication",
  Emergency_loadApplication_GoldenVisa: "/api/eservice/ServiceEmergencyPassportGoldenVisa/LoadApplication",
  Emergency_saveApplication_test: "/api/eservice/ServiceEmergencyPassport/SaveApplication",
  Emergency_saveApplication_GoldenVisa: "/api/eservice/ServiceEmergencyPassportGoldenVisa/SaveApplication",
  Emergency_EIDFromICAById: "/api/eservice/ServiceEmergencyPassport/GetEmiratesIdDetailsfromICAById",
  Emergency_EIDFromICAById_GoldenVisa: "/api/eservice/ServiceEmergencyPassportGoldenVisa/GetEmiratesIdDetailsfromICAById",
  //CRM ID Service   
  EmergancyPassport: '07ee172d-738d-ec11-910f-0050569917f4',
  GoldenEmergancyPassport: 'E53F0B35-1162-F011-912B-0050569917F4',
  NewBorn: 'fb50b8e3-728d-ec11-910f-0050569917f4',
  NewBorn_loadApplication: "/api/eservice/ServiceNewBorn/LoadApplication",
  NewBorn_saveApplication: "/api/eservice/ServiceNewBorn/SaveApplication",

  //ScatteredService
  ScatteredService: 'C65C28C2-17BB-EC11-910F-0050569917F4',
  ScatterdService_loadApplication: "/api/eservice/ScatteredService/LoadApplication",
  ScatterdService_saveApplication: "/api/eservice/ScatteredService/SaveApplication",

  //TaxExemption
  RegisterTaxExemption: 'cf1f8058-3f12-ed11-910f-0050569917f4',
  CancelTaxExemption: '48196300-4212-ed11-910f-0050569917f4',
  RegisterTaxExemption_loadApplication: "/api/eservice/RegisterTaxExempt/LoadApplication",
  RegisterTaxExemption_saveApplication: "/api/eservice/RegisterTaxExempt/SaveApplication",
  CancelTaxExemption_loadApplication: "/api/eservice/CancelTaxExempt/LoadApplication",
  CancelTaxExemption_saveApplication: "/api/eservice/CancelTaxExempt/SaveApplication",
  RegisterTaxExemption_searchBydiplomaticCardNumber: "/api/eservice/RegisterTaxExempt/SearchByDiplomaticCardNumber",

  //Main Deplomatic Visits
  MainDeplomaticVisits_loadApplication: "/api/eservice/MainDiplomaticVisits/LoadApplication",
  MainDeplomaticVisits_saveApplication: "/api/eservice/MainDiplomaticVisits/SaveApplication",
  CRMLoadSubVisitsRequest: "/api/eservice/MainDiplomaticVisits/CRMLoadSubVisitsRequest",
  //CRM Service ID
  MainDeplomaticVisits: '3272D9C7-431C-EB11-910A-0050569917F4',
  //Sub Deplomatic Visits
  SubDeplomaticVisits_loadApplication: "/api/eservice/SubDiplomaticVisits/LoadApplication",
  SubDeplomaticVisits_saveApplication: "/api/eservice/SubDiplomaticVisits/SaveApplication",
  CRMLoadMainVisitsRequest: "/api/eservice/SubDiplomaticVisits/CRMLoadMainVisitsRequest",
  CRMLoadFreqConfiguration: "/api/eservice/SubDiplomaticVisits/CRMLoadFreqConfiguration",


  //CRM Service ID
  //SubDeplomaticVisits  : '3272D9C7-431C-EB11-910A-0050569917F4',
  WirelessEquipmentService: "1BB24650-02D1-EC11-910F-0050569917F4",
  MediaEquipmentService: "83E52B20-14D1-EC11-910F-0050569917F4",
  WeaponPermitService: "016C748F-14D1-EC11-910F-0050569917F4",
  SubsidiaryMeetingService: "8DA59065-14D1-EC11-910F-0050569917F4",
  AviationPermitRequestService: "D8E96DEA-83DA-EC11-910F-0050569917F4",
  AirportHallsRequestService: "C7762C29-84DA-EC11-910F-0050569917F4",
  OtherService: "E2221E53-B5F2-EC11-910F-0050569917F4",

  // sub visit confirmtion

  SubVisit_RequestById: "/api/eservice/SubDiplomaticVisits/GetRequestById",
  SubmitApplicationUrl: "/api/eservice/SubDiplomaticVisits/SubmitApplication",
  SubVisit_ServiceGroupId: "8DA59065-14D1-EC11-910F-0050569917F4",

  // diplomatic meeting confirmation

  diplomaticmeetingconfirmation_RequestById: "/api/eservice/DiplomaticMeeting/GetRequestById",
  diplomaticmeetingconfirmation_SubmitApplicationUrl: "/api/eservice/DiplomaticMeeting/SubmitApplication",
  diplomaticmeetingconfirmation_ServiceGroupId: "8DA59065-14D1-EC11-910F-0050569917F4",

  // AramexBulletCities: "1419928d-400f-48a3-a7c9-38d5d29c816b,92e59f32-7de6-448c-8c9d-513a0aa9e575,650ea9b9-07d3-4a2a-9484-6d67793f2b94,978b22b1-4c90-473c-b750-63ad25bce1f3",


  //CRM Diplomatic Vehicle Services IDs
  DiplomaticVehicleRegistrationID: "A6A1466B-34AF-EC11-910F-0050569917F4",
  DiplomaticVehicleExportID: "3D9178CC-34AF-EC11-910F-0050569917F4",
  DiplomaticVehicleTransferID: "D3EFF37A-38AF-EC11-910F-0050569917F4",
  DiplomaticVehicleCancellingID: "E351882B-39AF-EC11-910F-0050569917F4",
  DiplomaticVehicleTourismID: "D36DE4C1-38AF-EC11-910F-0050569917F4",
  DiplomaticVehicleReplacementID: "C09D98FA-38AF-EC11-910F-0050569917F4",
  DiplomaticDrivingLicenseRenewID: "58CA4E1D-3DAF-EC11-910F-0050569917F4",
  DiplomaticParkingAssigmentRenewID: "C53737EA-3BAF-EC11-910F-0050569917F4",
  DiplomaticTrafficFinesExemption: "C2CCB65E-39AF-EC11-910F-0050569917F4",
  DiplomaticParkingFinesExemption: "CEE47FB1-3BAF-EC11-910F-0050569917F4",

  //Diplomatic Vehicle services
  registerDiplomaticVehicle_loadApplication: "/api/eservice/RegisterDiplomaticVehicle/LoadApplication",
  registerDiplomaticVehicle_saveApplication: "/api/eservice/RegisterDiplomaticVehicle/SaveApplication",
  registerDiplomaticVehicle_getCardNumber: "/api/eservice/RegisterDiplomaticVehicle/FindCardNumberByNumber",
  registerDiplomaticVehicle_getCardId: "/api/eservice/RegisterDiplomaticVehicle/FindCardIdById",

  exportDiplomaticVehicle_loadApplication: "/api/eservice/ExportDiplomaticVehicle/LoadApplication",
  exportDiplomaticVehicle_saveApplication: "/api/eservice/ExportDiplomaticVehicle/SaveApplication",
  exportDiplomaticVehicle_getCardNumber: "/api/eservice/ExportDiplomaticVehicle/FindCardNumberByNumber",
  exportDiplomaticVehicle_getCardId: "/api/eservice/ExportDiplomaticVehicle/FindCardIdById",

  transferDiplomaticVehicle_loadApplication: "/api/eservice/TransferDiplomaticVehicle/LoadApplication",
  transferDiplomaticVehicle_saveApplication: "/api/eservice/TransferDiplomaticVehicle/SaveApplication",
  transferDiplomaticVehicle_getCardNumber: "/api/eservice/TransferDiplomaticVehicle/FindCardNumberByNumber",
  transferDiplomaticVehicle_getCardId: "/api/eservice/TransferDiplomaticVehicle/FindCardIdById",

  cancellingDiplomaticVehicle_loadApplication: "/api/eservice/CancellingDiplomaticVehicle/LoadApplication",
  cancellingDiplomaticVehicle_saveApplication: "/api/eservice/CancellingDiplomaticVehicle/SaveApplication",
  cancellingDiplomaticVehicle_getCardNumber: "/api/eservice/CancellingDiplomaticVehicle/FindCardNumberByNumber",
  cancellingDiplomaticVehicle_getCardId: "/api/eservice/CancellingDiplomaticVehicle/FindCardIdById",

  tourismDiplomaticVehicle_loadApplication: "/api/eservice/TourismDiplomaticVehicle/LoadApplication",
  tourismDiplomaticVehicle_saveApplication: "/api/eservice/TourismDiplomaticVehicle/SaveApplication",
  tourismDiplomaticVehicle_getCardNumber: "/api/eservice/TourismDiplomaticVehicle/FindCardNumberByNumber",
  tourismDiplomaticVehicle_getCardId: "/api/eservice/TourismDiplomaticVehicle/FindCardIdById",

  replacementDiplomaticVehicle_loadApplication: "/api/eservice/ReplacementDiplomaticVehicle/LoadApplication",
  replacementDiplomaticVehicle_saveApplication: "/api/eservice/ReplacementDiplomaticVehicle/SaveApplication",
  replacementDiplomaticVehicle_getCardNumber: "/api/eservice/ReplacementDiplomaticVehicle/FindCardNumberByNumber",
  replacementDiplomaticVehicle_getCardId: "/api/eservice/ReplacementDiplomaticVehicle/FindCardIdById",

  drivingLicenseRenewDiplomatic_loadApplication: "/api/eservice/DrivingLicenseRenewDiplomatic/LoadApplication",
  drivingLicenseRenewDiplomatic_saveApplication: "/api/eservice/DrivingLicenseRenewDiplomatic/SaveApplication",
  drivingLicenseRenewDiplomatic_getCardNumber: "/api/eservice/DrivingLicenseRenewDiplomatic/FindCardNumberByNumber",
  drivingLicenseRenewDiplomatic_getCardId: "/api/eservice/DrivingLicenseRenewDiplomatic/FindCardIdById",

  parkingAssignmentRenewalDiplomatic_loadApplication: "/api/eservice/ParkingAssignmentDiplomatic/LoadApplication",
  parkingAssignmentRenewalDiplomatic_saveApplication: "/api/eservice/ParkingAssignmentDiplomatic/SaveApplication",
  parkingAssignmentRenewalDiplomatic_getCardNumber: "/api/eservice/ParkingAssignmentDiplomatic/FindCardNumberByNumber",
  parkingAssignmentRenewalDiplomatic_getCardId: "/api/eservice/ParkingAssignmentDiplomatic/FindCardIdById",

  trafficFinesExemptionDiplomatic_loadApplication: "/api/eservice/TrafficFinesExemptionDiplomatic/LoadApplication",
  trafficFinesExemptionDiplomatic_saveApplication: "/api/eservice/TrafficFinesExemptionDiplomatic/SaveApplication",
  trafficFinesExemptionDiplomatic_getCardNumber: "/api/eservice/TrafficFinesExemptionDiplomatic/FindCardNumberByNumber",
  trafficFinesExemptionDiplomatic_getOrganization: "/api/eservice/TrafficFinesExemptionDiplomatic/GetOrganization",
  trafficFinesExemptionDiplomatic_getCardId: "/api/eservice/TrafficFinesExemptionDiplomatic/FindCardIdById",
  trafficFinesExemptionDiplomatic_getVisitRequestNumberNonGCC: "/api/eservice/TrafficFinesExemptionDiplomatic/GetVisitRequestNumberNonGCC",

  parkingFinesExemptionDiplomatic_loadApplication: "/api/eservice/ParkingFinesExemptionDiplomatic/LoadApplication",
  parkingFinesExemptionDiplomatic_saveApplication: "/api/eservice/ParkingFinesExemptionDiplomatic/SaveApplication",
  parkingFinesExemptionDiplomatic_getCardNumber: "/api/eservice/ParkingFinesExemptionDiplomatic/FindCardNumberByNumber",
  parkingFinesExemptionDiplomatic_getCardId: "/api/eservice/ParkingFinesExemptionDiplomatic/FindCardIdById",

  //CRM Attestation Valid Services IDs
  AttestOfficalCertificateID: "65EE372C-0D08-ED11-910F-0050569917F4",

  attestOfficalCertificate_loadApplication: "/api/eservice/AttestOfficalCertificate/LoadApplication",
  attestOfficalCertificate_saveApplication: "/api/eservice/AttestOfficalCertificate/SaveApplication",
  attestOfficalCertificate_getAttestOfficalCertificate: "/api/eservice/AttestOfficalCertificate/GetAttestationValidationByRequestId",
  //CountryExecluseive: "100429f6-3c58-4674-8f88-ae439f94408a,6a569bf9-7922-4923-b43b-b44dd105e32a",

  //CRM Request Searching Investigation Services IDs
  RequestSearchingInvestigationID: "E2ADEBC0-12EE-EC11-910F-0050569917F4",

  // Inquiries Foreign Nationals Services
  requestSearchingInvestigation_loadApplication: "/api/eservice/RequestSearchingInvestigation/LoadApplication",
  requestSearchingInvestigation_saveApplication: "/api/eservice/RequestSearchingInvestigation/SaveApplication",
  requestSearchingInvestigation_checkINFNExist: "/api/eservice/RequestSearchingInvestigation/CheckINFNExist",

  enquiryAboutArrestedPrisonerInvestigation_loadApplication: "/api/eservice/EnquiryAboutArrestedPrisoner/LoadApplication",
  enquiryAboutArrestedPrisonerInvestigation_saveApplication: "/api/eservice/EnquiryAboutArrestedPrisoner/SaveApplication",
  enquiryAboutArrestedPrisonerInvestigation_checkINFNExist: "/api/eservice/EnquiryAboutArrestedPrisoner/CheckINFNExist",

  othersInquiries_loadApplication: "/api/eservice/OthersInquiries/LoadApplication",
  othersInquiries_saveApplication: "/api/eservice/OthersInquiries/SaveApplication",
  othersInquiries_checkINFNExist: "/api/eservice/OthersInquiries/CheckINFNExist",

  requestAboutGeneralStatistics_loadApplication: "/api/eservice/RequestAboutGeneralStatistics/LoadApplication",
  requestAboutGeneralStatistics_saveApplication: "/api/eservice/RequestAboutGeneralStatistics/SaveApplication",
  requestAboutGeneralStatistics_checkINFNExist: "/api/eservice/RequestAboutGeneralStatistics/CheckINFNExist",

  mattersOfLaborAndWorkers_loadApplication: "/api/eservice/MattersOfLaborAndWorkers/LoadApplication",
  mattersOfLaborAndWorkers_saveApplication: "/api/eservice/MattersOfLaborAndWorkers/SaveApplication",
  mattersOfLaborAndWorkers_checkINFNExist: "/api/eservice/MattersOfLaborAndWorkers/CheckINFNExist",

  mattersOfHealthAndMortality_loadApplication: "/api/eservice/MattersOfHealthAndMortality/LoadApplication",
  mattersOfHealthAndMortality_saveApplication: "/api/eservice/MattersOfHealthAndMortality/SaveApplication",
  mattersOfHealthAndMortality_checkINFNExist: "/api/eservice/MattersOfHealthAndMortality/CheckINFNExist",

  judicialAssistance_loadApplication: "/api/eservice/JudicialAssistance/LoadApplication",
  judicialAssistance_saveApplication: "/api/eservice/JudicialAssistance/SaveApplication",
  judicialAssistance_checkINFNExist: "/api/eservice/JudicialAssistance/CheckINFNExist",

  extraditionRequests_loadApplication: "/api/eservice/ExtraditionRequests/LoadApplication",
  extraditionRequests_saveApplication: "/api/eservice/ExtraditionRequests/SaveApplication",
  extraditionRequests_checkINFNExist: "/api/eservice/ExtraditionRequests/CheckINFNExist",

  requestsOfJudicialReporting_loadApplication: "/api/eservice/RequestsOfJudicialReporting/LoadApplication",
  requestsOfJudicialReporting_saveApplication: "/api/eservice/RequestsOfJudicialReporting/SaveApplication",
  requestsOfJudicialReporting_checkINFNExist: "/api/eservice/RequestsOfJudicialReporting/CheckINFNExist",

  requestsForClemencyAndAmnesty_loadApplication: "/api/eservice/RequestsForClemencyAndAmnesty/LoadApplication",
  requestsForClemencyAndAmnesty_saveApplication: "/api/eservice/RequestsForClemencyAndAmnesty/SaveApplication",
  requestsForClemencyAndAmnesty_checkINFNExist: "/api/eservice/RequestsForClemencyAndAmnesty/CheckINFNExist",

  matterOfElection_loadApplication: "/api/eservice/MattersOfElection/LoadApplication",
  matterOfElection_saveApplication: "/api/eservice/MattersOfElection/SaveApplication",
  matterOfElection_checkINFNExist: "/api/eservice/MattersOfElection/CheckINFNExist",

  matterOfEvents_loadApplication: "/api/eservice/MattersOfEvents/LoadApplication",
  matterOfEvents_saveApplication: "/api/eservice/MattersOfEvents/SaveApplication",
  matterOfEvents_checkINFNExist: "/api/eservice/MattersOfEvents/CheckINFNExist",

  matterOfEducation_loadApplication: "/api/eservice/MattersOfEducation/LoadApplication",
  matterOfEducation_saveApplication: "/api/eservice/MattersOfEducation/SaveApplication",
  matterOfEducation_checkINFNExist: "/api/eservice/MattersOfEducation/CheckINFNExist",


  //Diplomatic Luggage
  DiplomaticLuggage_loadApplication: "/api/eservice/DiplomaticLuggage/LoadApplication",
  DiplomaticLuggage_saveApplication: "/api/eservice/DiplomaticLuggage/SaveApplication",
  IsUSAUser: "/api/eservice/DiplomaticLuggage/IsUSAUser",
  //CRM Service ID
  DiplomaticLuggage: '084b999a-8e06-ed11-910f-0050569917f4',

  // MunicipalityFee
  municipalityFee_loadApplication: "/api/eservice/MunicipalityFee/LoadApplication",
  municipalityFee_saveApplication: "/api/eservice/MunicipalityFee/SaveApplication",
  municipalityFee_getCardNumber: "/api/eservice/MunicipalityFee/FindCardNumberByNumber",
  municipalityFee_findCardIdById: "/api/eservice/MunicipalityFee/FindCardIdById",
  municipalityFee_ValidateContractNumber: "/api/eservice/MunicipalityFee/ValidateContractNumber",

  //CRM Service ID
  municipalityFee: 'C6302AB8-C234-ED11-9111-0050569917F4',

  //Invitation Service
  Invitation_ServiceId: "BFF90A91-7E84-ED11-9113-0050569917F4",
  Invitation_Individual_ServiceId: "E3E7D8BF-EC4A-EE11-9117-0050569917F4",
  Invitation_UnderProcessId: "1dbe4e27-64f0-ec11-910f-0050569917f4",
  Invitation_loadApplication: "/api/eservice/Invitation/LoadApplication",
  Invitation_saveApplication: "/api/eservice/Invitation/SaveApplication",
  Invitation_RequestById: "/api/eservice/Invitation/GetRequestById",
  Invitation_RequestsStatus: "/api/eservice/Invitation/GetRequestsStatus",
  Invitation_GetInviteeToConfirm: "/api/eservice/Invitation/GetInviteeToConfirm",
  Invitation_ConfirmInvitee: "/api/eservice/Invitation/ConfirmInvitee",
  Invitation_loadRequestByCRMId: "/api/eservice/Invitation/GetRequestByCRMId",
  Invitation_ConfirmationRequestByCRMId: "/api/eservice/Invitation/ValidateConfirmationRequestByCRMId",
  Invitation_ServiceGroupId: "7A0805B4-31EE-ED11-9116-0050569917F4",
  Invitation_ConfirmationTitileLookup: "/api/eservice/Lookup/LoadLookup",
  document_crmGetServiceDocumentConfiguration: "/api/eservice/CRMDocument/GetServiceDocumentConfiguration",

  // ApiKey: "AIzaSyDRBkahVxI1cT3YekzIIyWQjk3LtUUDfIE",
  ApiKey: "AIzaSyDj9danrfE0LT0cuRG_ux2fmMuOSXWtJCE",  // prod
  //ApiKey: "AIzaSyDcNLmrNReQEjzZpRytvbANJ9hNU9g6bwo"

  // Speech And Letter Services Id
  SpeechAndLetterServiceId: "BBD5E09B-F6B0-ED11-9113-0050569917F4",
  SpeechAndLetterIndividualServiceId: "A1AA48F5-A04C-EE11-9117-0050569917F4",

  //Speech And Letter Service
  SpeechAndLetter_loadApplication: "/api/eservice/SpeechAndLetters/LoadApplication",
  SpeechAndLetter_saveApplication: "/api/eservice/SpeechAndLetters/SaveApplication",

  // Telegram Services Id
  TelegramServiceId: "78506A05-76A0-ED11-9113-0050569917F4",
  TelegramIndividualServiceId: "A1AA48F5-A04C-EE11-9117-0050569917F4",

  //Telegram Service
  Telegram_loadApplication: "/api/eservice/Telegram/LoadApplication",
  Telegram_saveApplication: "/api/eservice/Telegram/SaveApplication",

  //Visit Prisoner Permit Request
  VisitPrisonerPermitRequestServiceId: "5FDBF990-2247-EE11-9117-0050569917F4",
  VisitPrisonerPermitRequest_loadApplication: "/api/eservice/VisitPrisonerPermitRequest/LoadApplication",
  VisitPrisonerPermitRequest_saveApplication: "/api/eservice/VisitPrisonerPermitRequest/SaveApplication",
  VisitPrisonerPermitRequest_ValidateIdNumber: "/api/eservice/VisitPrisonerPermitRequest/ValidateDeplomaticIdNumber",
  VisitPrisonerPermitRequest_FindContactByEmiratedIdandDOB: "/api/eservice/VisitPrisonerPermitRequest/FindContactByEmiratedIdandDOB",
  VisitPrisonerPermitRequest_GetContactByContactId: "/api/eservice/VisitPrisonerPermitRequest/GetContactByContactId",
  VisitPrisonerPermitRequest_GetAllowedContactsByOrgId: "/api/eservice/VisitPrisonerPermitRequest/GetAllowedContactsByOrgId",
  VisitPrisonerPermitRequest_GetFullContactsDetailsById: "/api/eservice/VisitPrisonerPermitRequest/GetFullContactsDetailsById",
  VisitPrisonerPermitRequest_VisitorContactSave: "/api/eservice/VisitPrisonerPermitRequest/VisitorContactSave",
  VisitPrisonerPermitRequest_DeleteExistingVisitor: "/api/eservice/VisitPrisonerPermitRequest/DeleteExistingVisitor",
  VisitPrisonerPermitRequest_GetDeplomaticIDDetailsByContactId: "/api/eservice/VisitPrisonerPermitRequest/GetDeplomaticIDDetailsByContactId",

  //Aviation And Marine Permit
  AviationAndMarinePermit_ServiceId: "252D169C-1DAA-EE11-9119-0050569917F4",
  AviationAndMarinePermit_loadApplication: "/api/eservice/AviationAndMarinePermit/LoadApplication",
  AviationAndMarinePermit_saveApplication: "/api/eservice/AviationAndMarinePermit/SaveApplication",
  AnnualAviationAndMarinePermit_loadApplication: "/api/eservice/AnnualAviationAndMarinePermit/LoadApplication",
  AnnualAviationAndMarinePermit_saveApplication: "/api/eservice/AnnualAviationAndMarinePermit/SaveApplication",
  PrivateAviationAndMarinePermit_loadApplication: "/api/eservice/AviationAndMarinePermit/LoadApplication",
  PrivateAviationAndMarinePermit_saveApplication: "/api/eservice/AviationAndMarinePermit/SaveApplication",
  CancelAviationAndMarinePermit_loadApplication: "/api/eservice/CancelAviationAndMarinePermit/LoadApplication",
  CancelAviationAndMarinePermit_saveApplication: "/api/eservice/CancelAviationAndMarinePermit/SaveApplication",
  AviationAndMarinePermitCRMLoadMainVisitsRequest: "/api/eservice/SubDiplomaticVisits/CRMLoadMainVisitsRequest",

  //Virtual Meetings 
  VirtualMeetingAndPhoneCall_ServiceId: "931E12C5-A5C5-EE11-911A-0050569917F4",
  VirtualMeeting_loadApplication: "/api/eservice/VirtualMeeting/LoadApplication",
  VirtualMeeting_saveApplication: "/api/eservice/VirtualMeeting/SaveApplication",
  PhoneCall_loadApplication: "/api/eservice/PhoneCall/LoadApplication",
  PhoneCall_saveApplication: "/api/eservice/PhoneCall/SaveApplication",

  //Diplomatic meeting
  DiplomaticMeeting_ServiceId: "1AFB48A1-85E6-EE11-911A-0050569917F4",
  DiplomaticMeeting_loadApplication: "/api/eservice/DiplomaticMeeting/LoadApplication",
  DiplomaticMeeting_saveApplication: "/api/eservice/DiplomaticMeeting/SaveApplication",
  DiplomaticMeeting_findByIDForDiplomat: "/api/eservice/DiplomaticMeeting/FindByIDForDiplomat",

  //Non Deplomatic Visits
  NonDeplomaticVisits_loadApplication: "/api/eservice/NonDiplomaticVisits/LoadApplication",
  NonDeplomaticVisits_saveApplication: "/api/eservice/NonDiplomaticVisits/SaveApplication",
  NonCRMLoadMainVisitsRequest: "/api/eservice/NonDiplomaticVisits/CRMLoadMainVisitsRequest",

  //International Judicial Cooperation
  InternationalJudicialCooperation_ServiceId: "F5454822-A316-EF11-911C-0050569917F4",
  InternationalJudicialCooperation_loadApplication: "/api/eservice/InternationalJudicialCooperation/LoadApplication",
  InternationalJudicialCooperation_saveApplication: "/api/eservice/InternationalJudicialCooperation/SaveApplication",
  InternationalJudicialCooperation_RequestsByUserID: "/api/eservice/InternationalJudicialCooperation/GetRequestsByUserID",

 //To whom it may concern
  TWIMC_loadServiceList: "/api/eservice/TWIMCMedical/GetTWIMCServices",
  TWIMCStudy_loadApplication: "/api/eservice/TWIMCStudy/LoadApplication",
  TWIMCStudy_saveApplication: "/api/eservice/TWIMCStudy/SaveApplication",
  TWIMCStudyID: '1F928EE2-B3F3-ED11-9116-0050569917F4',
  TWIMMarriage_loadApplication: "/api/eservice/TWIMCMarriage/LoadApplication",
  TWIMMarriage_saveApplication: "/api/eservice/TWIMCMarriage/SaveApplication",
  TWIMMarriageID: '6F6F687B-B7F3-ED11-9116-0050569917F4',
  TWIMCMedical_loadApplication: "/api/eservice/TWIMCMedical/LoadApplication",
  TWIMCMedical_saveApplication: "/api/eservice/TWIMCMedical/SaveApplication",
  TWIMCMedicalID: '8919249E-B7F3-ED11-9116-0050569917F4',

  //DigitalAttestation
  digitalAttestation_loadApplication: "/api/eservice/DigitalAttestation/LoadApplication",
  digitalAttestation_saveApplication: "/api/eservice/DigitalAttestation/SaveApplication",
  digitalAttestation_getUserPendingDocument: "/api/eservice/DigitalAttestation/GetUserPendingDocument",
  //digitalAttestation_getEDASDocument: "/api/eservice/DigitalAttestation/GetDownloadableLinkForEDAS",
  digitalAttestation_getEDASDocument: "/api/eservice/DigitalAttestation/GetBase64FilePDF",
  digitalAttestation_getEDASBase64Document: "/api/eservice/DigitalAttestation/GetDownloadableBase64ForEDAS",
  digitalAttestation_getAttestedDocumentFile: "/api/eservice/DigitalAttestation/GetAttestedFile",
  digitalAttestation_getAttestedFileBase64: "/api/eservice/DigitalAttestation/GetAttestedFileBase64",
  digitalAttestation_getUserAttestedDocuments: "/api/eservice/DigitalAttestation/GetUserAttestedDocument",
  //renewID_findByID: "/api/eservice/RenewID/FindByID",
  form_builder_get_form: "/api/formbuilder/GetForm",
  form_builder_submit_form: "/api/formbuilder/SubmitForm",

  //CRMScholarship
  CRMScholarship_ServiceId:"438666B7-1915-F011-912B-0050569917F4",
  CRMScholarship_loadApplication: "/api/eservice/CRMScholarship/LoadApplication",
  CRMScholarship_saveApplication: "/api/eservice/CRMScholarship/SaveApplication",
  CRMScholarship_findByID: "/api/eservice/CRMScholarship/IsIDNumberHasRequest",
  CRMScholarship_isServiceavailable: "/api/eservice/CRMScholarship/IsServiceAvailable",
  CRMScholarship_CheckApplication: "/api/eservice/CRMScholarship/CheckApplication",
  CRMScholarship_TopUniversities: "/api/features/TopUniversities/GetTopUniversitiesListAPI",

  //RecaptchaV3
  RecaptchaV3SiteStgKey: "6Ldvn-IrAAAAAI1KMH4QEmcX4UbVktCTk-dhUzAE",
  RecaptchaV3SitePrdKey: "6LfUpPErAAAAAKZgF-yl8ODqLciMzW8HvzQyFET5",


  //VisitDelegationOutsideUAE
  VisitDelegationOutsideUAE_serviceId: 'b585f559-9e3f-f011-912b-0050569917f4',
  VisitDelegationOutsideUAE_loadApplication: "/api/eservice/VisitDelegationOutsideUAE/LoadApplication",
  VisitDelegationOutsideUAE_saveApplication: "/api/eservice/VisitDelegationOutsideUAE/SaveApplication",
  VisitDelegationOutsideUAE_countryUAEMissionUrl: "/api/eservice/VisitDelegationOutsideUAE/GetCountryUAEMission",
  VisitDelegationOutsideUAE_organizationRelatedRequestsUrl: "/api/eservice/VisitDelegationOutsideUAE/GetOrganizationRelatedRequests"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
